import { render } from "./ClaimProcessModal.vue?vue&type=template&id=4de58ff5&scoped=true"
import script from "./ClaimProcessModal.vue?vue&type=script&lang=js"
export * from "./ClaimProcessModal.vue?vue&type=script&lang=js"

import "./ClaimProcessModal.vue?vue&type=style&index=0&id=4de58ff5&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de58ff5"]])

export default __exports__